import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";

const Checkout = () => {
  const location = useLocation();
  const { shippingMethod, tprice, totalPrice, qnt, basePrice, img, pqnt,cart } =
    location.state || {};

  return (
    <section className="Returning_sec">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <div className="Returning">
              <i className="fa-solid fa-user"></i> Returning customer?
              <span>
                <a href="/login">Click here to login</a>
              </span>
            </div>
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="Returning">
              <i className="fa-solid fa-money-bill"></i> Have a coupon?
              <span>
                <a href="/coupon">Click here to enter your code</a>
              </span>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-4 col-md-12">
            <div className="checkout_Product_box">

            {cart?.map((item) => (
              <div className="checkout_Product">
                <div className="checkout_img">
                  <img
                    src={item.image}
                    className="productcheckout_img"
                    alt="Product"
                  />
                </div>
                <div className="text_check">
                  {item.name}
                   <br />
                  
                  <strong>QTY : {pqnt}</strong>
                </div>
                <div className="price_check">{basePrice}</div>
              </div>
            ))}


              <div className="Subtotal_box">
                <p>Subtotal</p>

                <p>{totalPrice}</p>
              </div>

              <div className="totals_shipping_1">
                <h2>Shipping</h2>
                <div data-title="Shipping">
                  <ul
                    id="shipping_method"
                    className="woocommerce-shipping-methods"
                  >
                    {shippingMethod.name}
                  </ul>
                </div>
              </div>

              <div className="totals_shipping_1">
                <h2>Total Quantity</h2>
                <div data-title="Shipping">
                  <ul
                    id="shipping_method"
                    className="woocommerce-shipping-methods"
                  >
                    {qnt}
                  </ul>
                </div>
              </div>

              

              <div className="order-total">
                <h2>Total Price</h2>
                <div className="total-price">
                  <strong>
                    <span className="woocommerce-Price-amount amount">
                      <bdi>
                        <span className="woocommerce-Price-currencySymbol">
                          $
                        </span>
                        {tprice}
                      </bdi>
                    </span>
                  </strong>
                </div>
              </div>

              <div className="bank_transfer">
                <div className="transfer"></div>
              </div>
            </div>

            <div className="Place_order_box">
              <Link to="/odersubmission" className="Place_order">
                Place order{img}
              </Link>
            </div>
          </div>
        </div>

        <ToastContainer />
      </div>
    </section>
  );
};

export default Checkout;
